var total_price = 0; // Initialize the total price variable

var is_length = $('.data-price').length;
if (is_length > 0) {
  $('.data-price').each(function () {
    var single_price = parseFloat($(this).attr('data-price'));
    total_price += single_price; // Add the current price to the total
  });
}
var new_val = total_price.toFixed(2)
console.log("Total Price:", total_price.toFixed(2));
$('.totals__subtotal-value').text('£'+new_val+' GBP');
$('.header-cart-count').text('£'+new_val);
var cookie_timer = setInterval(() => {
    var cookie_element = document.getElementById("cb-cookie_consent");
    if (cookie_element) {
        var announcement_elem = document.getElementById("shopify-section-announcement-bar");
        announcement_elem.insertBefore(cookie_element, announcement_elem.children[0]);
        $("#cb-cookie_consent").addClass("moved");
        clearInterval(cookie_timer);
    }
}, 1000);

// custom product card link
$(document).on("click", ".custom-card-product div[role='custom-product-card']", function(){
    var product_link = $(this).attr("product-link");
    // console.log(product_link);
    location.href = product_link;
});

// custom product card add to cart 

$(document).on("click", ".add-to-basket-button.custom-cart-call:not([disabled])", function () {
    let id = $(this).closest(".custom-card-product").find("input[name='id']").val();
    add_items_to_cart(id, 1,  "open_slider", null);
 });

// $(document).on("click", ".custom-dynamic-checkout:not([disabled])", function () {
//   console.log('INnnnnnnnnnnn')
//     let id = $(this).closest(".custom-card-product").find("input[name='id']").val();
//     add_items_to_cart(id, 1,  "open_slider1", null);
  
//  });

$(document).on("click",".upsell-cart-button", function () {
    let id = $(this).attr("vt-id");
    add_items_to_cart(id, 1, "open_slider", null);
});   


$(document).ready(function(){
    $('body').on('click','.description_data',function(e){
        e.preventDefault();
        var desc = $(this).attr('data-description');
        var desc_title = $(this).attr('data-title');
        $(this).hide();
        $('.description_data.'+desc_title).show();
        $('.rich-text-content').hide();
        $('.rich-text-content.'+desc).show();         
    });

  $('.sub-collection').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    infinite: false,
     responsive: [
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 1360,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 1160,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
     {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
       {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false
      }
    },
        {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
      }
    }
  ]
  });

});